<template>
	<div class="NVF__Primary">
		<div class="NVF__Primary__Wrapper">
			<div class="NVF__Primary__header">
				<p class="NVF__Primary__header__p1">
					{{ $t('common-verify-flow.kyc_verify') }}
				</p>
				<p class="NVF__Primary__header__p2">
					{{ $t('common-verify-flow.b1') }}
				</p>
			</div>
			<div class="NVF__Primary__desc1">
				{{ $t('common-verify-flow.starter-desc-3') }}
			</div>
			<div id="NVF__Primary_Primary--loading">
				<div class="NVF__Primary__Content">
					<div class="NVF__Primary__Box NVF__Primary__Box1">
						<div class="NVF__Primary__Box--desc">
							{{ $t('common-verify-flow.starter-desc-1') }}
							<span>{{ $t('common-verify-flow.starter-desc-2') }}</span>
						</div>
					</div>
				</div>
				<el-form
					ref="form"
					:model="form"
					label-position="top"
					:rules="rules"
					hide-required-asterisk
					width="70%"
					@validate="onformValidate"
				>
					<el-form-item prop="country" :label="$t('common-verify-flow.starter-form-country')" :required="true">
						<r-select
							v-model="form.country"
							:placeholder="$t('common-verify-flow.placeholder_country')"
							style="width: 100%"
							class="NVF__Primary__input NVF__Primary__country-select"
							filterable
							:disabled="hasVerify"
							size="large"
							@change="selectCountryChange"
							:popper-append-to-body="false"
						>
							<template #prefix>
								<div
									v-if="currentCountry && currentCountry.flag !== 'x'"
									class="country-select-prefix-icon"
									v-html="currentCountry.flag"
								/>
								<div v-else class="country-select-prefix-icon">
									<img src="../img/icon-country.svg" />
								</div>
							</template>
							<r-option
								v-for="item in supoprtedCountries"
								:key="item.code"
								:label="locale === 'cn' ? item.cn : item.desc"
								:value="item.code"
							>
								<div class="NVF__Primary__options">
									<span v-if="item.flag !== 'x'" class="NVF__Primary__options-img" v-html="item.flag"></span>
									<span v-else class="NVF__Primary__options-img"><img src="../img/icon-country.svg" /></span>
									<span style="margin-left: 10px">{{ locale === 'cn' ? item.cn : item.desc }}</span>
								</div>
							</r-option>
						</r-select>
					</el-form-item>
					<div class="NVF__Primary_username" style="display: flex; justify-content: space-between">
						<el-form-item
							:label="
								form.country.toUpperCase() === 'KR'
									? $t('common-verify-flow.starter-form-firstName-enkr')
									: $t('common-verify-flow.starter-form-firstName')
							"
							prop="firstNameEn"
						>
							<el-input
								v-model="form.firstNameEn"
								:placeholder="
									form.country.toUpperCase() === 'KR'
										? $t('common-verify-flow.starter-form-firstName-enkr')
										: $t('common-verify-flow.starter-form-firstName')
								"
								class="NVF__Primary__input"
								:disabled="hasVerify"
							/>
						</el-form-item>
						<el-form-item
							:label="
								form.country.toUpperCase() === 'KR'
									? $t('common-verify-flow.starter-form-lastName-enkr')
									: $t('common-verify-flow.starter-form-lastName')
							"
							prop="lastNameEn"
						>
							<el-input
								v-model="form.lastNameEn"
								:placeholder="
									form.country.toUpperCase() === 'KR'
										? $t('common-verify-flow.starter-form-lastName-enkr')
										: $t('common-verify-flow.starter-form-lastName')
								"
								class="NVF__Primary__input"
								:disabled="hasVerify"
							/>
						</el-form-item>
					</div>
					<div
						class="NVF__Primary_username"
						v-if="form.country.toUpperCase() === 'KR'"
						style="display: flex; justify-content: space-between"
					>
						<el-form-item :label="$t('common-verify-flow.starter-form-firstName-kr')" prop="firstName">
							<el-input
								v-model="form.firstName"
								:placeholder="$t('common-verify-flow.starter-form-firstName-kr')"
								class="NVF__Primary__input"
								:disabled="hasVerify"
							/>
						</el-form-item>
						<el-form-item :label="$t('common-verify-flow.starter-form-lastName')" prop="lastName">
							<el-input
								v-model="form.lastName"
								:placeholder="$t('common-verify-flow.starter-form-lastName')"
								class="NVF__Primary__input"
								:disabled="hasVerify"
							/>
						</el-form-item>
					</div>
					<el-form-item :label="$t('common-verify-flow.starter-form-birthday')" prop="birthday">
						<el-date-picker
							type="date"
							v-model="form.birthday"
							class="NVF__Primary__input"
							style="width: 100%"
							:placeholder="$t('common-verify-flow.placeholder_date')"
							value-format="yyyy-MM-dd"
							:disabled="hasVerify"
						/>
					</el-form-item>
					<el-form-item class="NVF__Primary__SubmitBtn_Form-Item">
						<r-button2
							:class="[
								'NVF__Primary__SubmitBtn',
								{
									['NVF__Primary__LinkDisable']: hasVerify,
								},
							]"
							:disabled="formDisabled"
							@click="submit"
							type="primary"
							size="large"
						>
							<i v-if="submiting" class="el-icon-loading" />
							{{ $t('common-verify-flow.starter-form-btn-confirm') }}
						</r-button2>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>
<script>
import { axiosClient } from '~/common/js/axios';
// import { isLoginedToken } from '~/common/js/utils'
import { countryNameMap } from '../../../helper/country-name';
import Cookies from 'js-cookie';
import moment from 'moment';
import twemoji from 'twemoji';
import messages from '../i18n';
import { firebaseLogEvent } from '../../../helper/util';
import { usePatchStore } from '~/common/js/patch';

export default {
	i18n: { messages },
	name: 'StarterVerification',
	computed: {
		locale() {
      return this.store.locale;
    },
    cid() {
      return this.store.account.cid;
    },
	},
	props: {
		supoprtedCountries: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			form: {
				country: '',
				firstNameEn: '',
				firstName: '',
				lastNameEn: '',
				lastName: '',
				birthday: '',
			},
			// supoprtedCountries: [],
			submiting: false,
			rules: {
				country: [
					{
						required: true,
						message: this.$t('common-verify-flow.starter-form-country-require'),
						trigger: ['blur', 'change'],
					},
				],
				firstNameEn: [
					{
						required: true,
						message: this.$t('common-verify-flow.starter-form-firstName-require'),
						trigger: ['blur', 'change'],
					},
				],
				firstName: [
					{
						required: true,
						message: this.$t('common-verify-flow.starter-form-firstName-require'),
						trigger: ['blur', 'change'],
					},
				],
				lastNameEn: [
					{
						required: true,
						message: this.$t('common-verify-flow.starter-form-lastName-require'),
						trigger: ['blur', 'change'],
					},
				],
				lastName: [
					{
						required: true,
						message: this.$t('common-verify-flow.starter-form-lastName-require'),
						trigger: ['blur', 'change'],
					},
				],
				birthday: [
					{
						required: true,
						trigger: ['change'],
						message: this.$t('common-verify-flow.starter-form-birthday-require'),
					},
					{
						validator: (rule, value, callback) => {
							// console.log('birthday validator', value);
							if (!value) {
								// console.log('birthday validator', 111);
								callback(new Error(this.$t('common-verify-flow.starter-form-birthday-require')));
							} else if (moment().diff(new moment(value), 'years') < 18) {
								// console.log('birthday validator', 222);
								callback(new Error(this.$t('common-verify-flow.K_412')));
							} else {
								// console.log('birthday validator', 333);
								callback();
							}
						},
					},
				],
			},
			hasVerify: false,
			formDisabled: false,
			currentCountry: null,
		};
	},
	methods: {
		submit() {
			let loadingInstance;
			if (this.submiting || this.hasVerify) {
				return;
			}

			// setTimeout(() => {
			//   this.$emit('next')
			// }, 1000)

			this.$refs.form
				.validate()
				.then((isValidate) => {
					if (isValidate) {
						loadingInstance = this.$loading({
							target: '#NVF__Primary_Primary--loading',
						});
						this.submiting = true;
						// const token = Cookies.get('accessToken');
						const postData = { ...this.form };

						if (postData.country === 'KR') {
							// 韩国传参,不做处理，我觉得这样写清楚一点
						} else {
							// 非韩国传参
							postData.firstName = postData.firstNameEn;
							postData.lastName = postData.lastNameEn;
							delete postData.firstNameEn;
							delete postData.lastNameEn;
						}
						axiosClient({
							method: 'POST',
							url: '/gw-api/user-center/kyc/primary/applyV2',
							data: postData,
							// headers: {
							// 	Authorization: token,
							// },
						})
							.then((res) => {
								if (res?.success) {
									this.$emit('next');
								}

								firebaseLogEvent('af_kyc', {
									af_level: 1,
									af_user_id: this.cid,
									af_platform_type: 'WEB',
								});

								this.$af({
									event: 'af_kyc',
									data: {
										af_level: 1,
										af_user_id: this.cid,
										af_platform_type: 'H5',
									},
								});
							})
							.finally(() => {
								loadingInstance?.close();
								this.submiting = false;
							});
					}
				})
				.catch((err) => {});
		},
		onformValidate(rows, valid, error) {
			if (this.form.country && this.form.firstNameEn && this.form.lastNameEn && this.form.birthday) {
				if (moment().diff(new moment(this.form.birthday), 'years') >= 18) {
					this.formDisabled = false;
					return;
				}
			}
			this.formDisabled = true;
		},
		selectCountryChange(v) {
			const country = { ...countryNameMap[v] };
			country.flag = twemoji.parse(country.flag, {
				base: import.meta.env.TWEMOJI_CDN,
			});
			this.currentCountry = country;
		},
	},
	created() {
		this.countryNameMap = countryNameMap;
		this.twemoji = twemoji;
	},
	mounted() {
		// this.$emit('next')
	},
	setup() {
    const { store, commit } = usePatchStore();
    return {
      store,
      commit
    };
  }
};
</script>

<style lang="less">
.day-mode {
	--comp-verify-flow-dialog-verification-color-text: #1a1b1f;
	--comp-verify-flow-dialog-verification-color-text-400: #2b2e36;
	--comp-verify-flow-dialog-verification-color-text-300: #6a7c81;
	--comp-verify-flow-dialog-verification-color-text-200: #91a5b1;
	--comp-verify-flow-dialog-verification-color-text-reverse: #ffffff;

	--comp-verify-flow-dialog-verification-color-bg: #fff;
	--comp-verify-flow-dialog-verification-color-bg-400: #fbfbfd;
	--comp-verify-flow-dialog-verification-color-bg-300: #eef3f5;
	// --comp-verify-flow-dialog-verification-color-bg-reverse: #383d4d;
}

.night-mode {
	--comp-verify-flow-dialog-verification-color-text: #ffffff;
	--comp-verify-flow-dialog-verification-color-text-400: #ffffff;
	--comp-verify-flow-dialog-verification-color-text-300: #a4a8b6;
	--comp-verify-flow-dialog-verification-color-text-200: #5b5f6c;
	--comp-verify-flow-dialog-verification-color-text-reverse: #1a1b1f;

	--comp-verify-flow-dialog-verification-color-bg: #2a2d37;
	--comp-verify-flow-dialog-verification-color-bg-400: #313542;
	--comp-verify-flow-dialog-verification-color-bg-300: #383d4d;
	// --comp-verify-flow-dialog-verification-color-bg-reverse: #fafafa;
}
</style>
<style lang="less">
@import '~/common/css/element-base-type.less';

.country-select-prefix-icon {
	margin: 0 10px;
	display: flex;
	align-items: center;
	height: 100%;
	width: 24px;
	img {
		width: 100%;
	}
}

.NVF__Primary {
	box-sizing: border-box;
	width: 100%;

	// :global {
	//   .sarterVerification-fade-enter-active {
	//     transition: opacity 0.5s;
	//   }
	//   .sarterVerification-fade-enter {
	//     opacity: 0;
	//   }
	// }
	&__Wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	&__options {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 2em;
	}
	&__LinkDisable {
		color: #fff;
		opacity: 0.5;
		cursor: not-allowed;
	}
	&__SubmitBtn {
		width: 100%;
		// height: 48px;
		// text-align: center;
		// font-size: 14px;
		// line-height: 48px;
		// color: #fff;
		// background: @blue-base;
		// border-radius: 8px;
		// font-weight: 500;
		// cursor: pointer;
		margin-top: 2em !important;
	}
	.el-form-item__content {
		height: 48px;
	}
	.el-form-item {
		margin-bottom: 10px;
	}
	.el-form-item.is-required {
		.el-form-item__label:after {
			content: '*';
			color: #f5222d;
			margin-left: 4px;
		}
	}
	.el-form-item__label {
		height: 25px;
		line-height: 25px;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: var(--comp-verify-flow-dialog-verification-color-text-300, #6a7c81);
	}

	&__SubmitBtn_Form-Item {
		&.el-form-item {
			margin-bottom: 0px;
		}
		.el-form-item__content {
			height: auto;
		}
	}

	&__country-select {
		.el-input {
			background-color: transparent;
		}
		// .el-input.is-focus .el-input__inner {
		//   color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f) !important;
		//   background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5) !important;
		// }

		.el-input .el-input__suffix .el-select__caret {
			color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f) !important;
		}

		.el-input--prefix .el-input__inner {
			padding-left: 50px;
			color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f) !important;
			background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5) !important;
		}
	}
}

.NVF__Primary__options {
	.NVF__Primary__options-img {
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		img {
			width: 100%;
		}
	}
}

@media (max-width: 768px) {
	.NVF__Primary {
		padding: 0 1em;
		&__header {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-end;
			margin-bottom: 10px;
			&__p1 {
				font-size: 1.5em;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-style: normal;
				font-weight: 600;
				line-height: 1;
			}
			&__p2 {
				font-size: 0.7em;
				color: var(--comp-verify-flow-dialog-verification-color-text-400, #2b2e36);
				font-weight: 500;
				line-height: 1;
				margin-left: 10px;
			}
		}

		&__desc1 {
			margin-top: 0.2em;
			font-style: normal;
			font-weight: 400;
			font-size: 0.7em;
			color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
		}
		&__Content {
			margin-top: 0.2em;
			margin-bottom: 1.5em;
		}

		&__Box {
			&--p2 {
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-size: 0.8em;
				font-weight: 500;
				margin: 2.1em 0 0.8em 0;
			}
			&--desc {
				padding: 0.8em 1em;
				margin-top: 0.8em;
				font-style: normal;
				font-weight: normal;
				font-size: 12px;
				line-height: 16px;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				background-color: var(--comp-verify-flow-dialog-verification-color-bg-300, #eef3f5);
				border-radius: 0.2em;
				span {
					color: #f5222d;
				}
			}
		}
		&_username {
			display: flex;
			justify-content: space-between;
			width: 100%;
			.el-form-item {
				width: calc(50% - 10px);
			}
			.el-form-item__content {
				// width: 97%;
				margin: 0;
			}
			.el-input__prefix {
				.el-input__icon {
					color: #141f21;
				}
			}
		}

		&__input {
			width: 100%;
			border: none;
			overflow: hidden;
			border-color: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
			background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
			border-radius: 8px;
			.el-input__inner {
				border: none;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
				&::placeholder {
					color: var(--comp-verify-flow-dialog-verification-color-text-200, #91a5b1);
				}
			}
		}
	}
}
@media (min-width: 768px) {
	.NVF__Primary {
		&__header {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-end;
			margin-bottom: 10px;
			&__p1 {
				font-size: 24px;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-style: normal;
				font-weight: 500;
				line-height: 1;
			}
			&__p2 {
				margin-left: 10px;
				font-size: 14px;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-weight: 500;
				line-height: 1;
			}
		}

		&__desc1 {
			margin-top: 8px;
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
		}
		&__Content {
			display: block;
		}
		&_username {
			display: flex;
			justify-content: space-between;
			width: 100%;
			.el-input__inner {
				flex: 1;
				background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
			}
			.el-form-item {
				width: calc(50% - 20px);
			}
			// .el-form-item__content {
			//   width: 225px;
			// }
		}

		&__Box {
			&--p1 {
				font-size: 20px;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-weight: bold;
			}
			&--p2 {
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				font-size: 16px;
				font-weight: 500;
				margin: 42px 0 16px 0;
			}
			&--desc {
				padding: 16px 20px;
				margin-top: 18px;
				margin-bottom: 16px;
				font-style: normal;
				font-weight: normal;
				font-size: 14px;
				line-height: 20px;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				background-color: var(--comp-verify-flow-dialog-verification-color-bg-300, #eef3f5);
				border-radius: 4px;
				span {
					color: #f5222d;
				}
			}
		}
		&__input {
			width: 100%;
			border: none;
			overflow: hidden;
			border-color: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
			background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
			border-radius: 4px;
			& > input {
				// width: 50%;
			}
			.el-input__inner {
				border: none;
				color: var(--comp-verify-flow-dialog-verification-color-text, #1a1b1f);
				background: var(--comp-verify-flow-dialog-verification-color-bg-400, #eef3f5);
				&::placeholder {
					color: var(--comp-verify-flow-dialog-verification-color-text-200, #91a5b1);
				}
			}
		}
	}
}
</style>
